(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accio-pack-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: document.querySelector('[data-accio-pack-selector]')?.dataset.currency || 'USD' }).format(Number(cents) / 100);
    const initialize = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const section = root.closest('.shopify-section');
      const apply = (input) => {
        const variantId = input.dataset.variantId;
        root.querySelector('[data-pack-status]').textContent = input.dataset.variantTitle;
        root.querySelector('[data-pack-price]').textContent = money(input.dataset.price);
        const compare = root.querySelector('[data-pack-compare]');
        const hasCompare = Number(input.dataset.comparePrice) > Number(input.dataset.price);
        compare.hidden = !hasCompare;
        compare.textContent = hasCompare ? money(input.dataset.comparePrice) : '';
        root.querySelector('[data-pack-save]').textContent = hasCompare ? `${root.dataset.saveLabel} ${money(input.dataset.savings)} · ${input.dataset.savingsPercent}% off` : '';
        root.querySelector('[data-pack-unit]').textContent = `${money(input.dataset.unitPrice)} ${root.dataset.unitLabel}`;
        const nativeInput = section?.querySelector(`variant-picker [data-variant-id="${variantId}"]`);
        if (nativeInput && !nativeInput.checked) nativeInput.click();
        section?.querySelectorAll('product-form-component input[name="id"]').forEach((field) => {
          field.value = variantId;
          field.disabled = input.dataset.available !== 'true';
        });
        const sticky = section?.querySelector('sticky-add-to-cart');
        if (sticky) {
          sticky.dataset.currentVariantId = variantId;
          sticky.dataset.variantAvailable = input.dataset.available;
        }
      };
      root.addEventListener('change', (event) => { if (event.target.matches('[data-pack-variant]')) apply(event.target); });
      section?.querySelector('variant-picker')?.addEventListener('change', (event) => {
        const variantId = event.target?.dataset?.variantId;
        if (!variantId) return;
        const input = root.querySelector(`[data-pack-variant][data-variant-id="${variantId}"]`);
        if (input) {
          input.checked = true;
          apply(input);
        }
      });
      const initial = root.querySelector('[data-pack-variant]:checked');
      if (initial) apply(initial);
    };
    document.querySelectorAll('[data-accio-pack-selector]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-accio-pack-selector]').forEach(initialize));
  })();
  } catch(e) { console.error(e); }
})();

})();
